import { render, staticRenderFns } from "./SocialThemeItemComponent.vue?vue&type=template&id=06bae306&"
import script from "./SocialThemeItemComponent.vue?vue&type=script&lang=ts&"
export * from "./SocialThemeItemComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports